import { Icon, IconProps } from "@chakra-ui/react";

export function PDFIcon({ white, ...rest }: IconProps & { white?: boolean }) {
  return (
    <Icon
      height="24px"
      width="24px"
      viewBox="0 0 56 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_416_808)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.10599 0C2.30399 0 0.0329895 2.272 0.0329895 5.074V58.915C0.0329895 61.718 2.30399 63.989 5.10599 63.989H50.88C53.681 63.989 55.954 61.718 55.954 58.915V20.31L37.051 0L5.10599 0Z"
          fill={white ? "#fff" : "#E2574C"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56.001 20.357V21.357H43.201C43.201 21.357 36.889 20.097 37.073 14.65C37.073 14.65 37.281 20.357 43.076 20.357H56.001Z"
          fill={white ? "#fff" : "#B53629"}
        />
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.098 0.00598145V14.567C37.098 16.223 38.202 20.358 43.202 20.358H56.002L37.098 0.00598145Z"
          fill={white ? "black" : "white"}
        />
        <path
          d="M12.538 39.144C12.166 39.144 11.878 39.042 11.674 38.838C11.482 38.622 11.386 38.328 11.386 37.956V27.48C11.386 27.096 11.488 26.808 11.692 26.616C11.896 26.412 12.184 26.31 12.556 26.31H16.894C18.286 26.31 19.36 26.658 20.116 27.354C20.872 28.05 21.25 29.022 21.25 30.27C21.25 31.518 20.872 32.496 20.116 33.204C19.36 33.9 18.286 34.248 16.894 34.248H13.69V37.956C13.69 38.328 13.594 38.622 13.402 38.838C13.21 39.042 12.922 39.144 12.538 39.144ZM13.69 32.43H16.534C17.35 32.43 17.968 32.25 18.388 31.89C18.808 31.518 19.018 30.978 19.018 30.27C19.018 29.562 18.808 29.028 18.388 28.668C17.968 28.308 17.35 28.128 16.534 28.128H13.69V32.43ZM24.3522 39C23.9562 39 23.6502 38.898 23.4342 38.694C23.2302 38.478 23.1282 38.172 23.1282 37.776V27.534C23.1282 27.138 23.2302 26.838 23.4342 26.634C23.6502 26.418 23.9562 26.31 24.3522 26.31H27.8442C29.9682 26.31 31.6062 26.856 32.7582 27.948C33.9222 29.04 34.5042 30.606 34.5042 32.646C34.5042 33.666 34.3542 34.572 34.0542 35.364C33.7662 36.144 33.3342 36.804 32.7582 37.344C32.1942 37.884 31.4982 38.298 30.6702 38.586C29.8542 38.862 28.9122 39 27.8442 39H24.3522ZM25.4322 37.092H27.7002C28.4442 37.092 29.0862 37.002 29.6262 36.822C30.1782 36.63 30.6342 36.354 30.9942 35.994C31.3662 35.622 31.6422 35.16 31.8222 34.608C32.0022 34.044 32.0922 33.39 32.0922 32.646C32.0922 31.158 31.7262 30.048 30.9942 29.316C30.2622 28.584 29.1642 28.218 27.7002 28.218H25.4322V37.092ZM38.0271 39.144C37.6551 39.144 37.3611 39.042 37.1451 38.838C36.9411 38.622 36.8391 38.316 36.8391 37.92V27.534C36.8391 27.138 36.9411 26.838 37.1451 26.634C37.3611 26.418 37.6671 26.31 38.0631 26.31H44.3451C44.6571 26.31 44.8911 26.388 45.0471 26.544C45.2031 26.7 45.2811 26.922 45.2811 27.21C45.2811 27.51 45.2031 27.744 45.0471 27.912C44.8911 28.068 44.6571 28.146 44.3451 28.146H39.1431V31.728H43.9671C44.2671 31.728 44.4951 31.806 44.6511 31.962C44.8191 32.118 44.9031 32.34 44.9031 32.628C44.9031 32.928 44.8191 33.162 44.6511 33.33C44.4951 33.486 44.2671 33.564 43.9671 33.564H39.1431V37.92C39.1431 38.736 38.7711 39.144 38.0271 39.144Z"
          fill={white ? "black" : "white"}
        />
      </g>
      <defs>
        <clipPath id="clip0_416_808">
          <rect width="56" height="64" fill={white ? "black" : "white"} />
        </clipPath>
      </defs>
    </Icon>
  );
}
